module.exports = __webpack_public_path__ + "static/for_whom_state_institutions-0bc551edfddb86d0ea97e40cc44d3911.jpg";